
class Grade {
    constructor(data) {
        const { name } = data
        this.name = name
    }
}

export default Grade